export default __webpack_public_path__ + "static/RobotoMono-Bold-d8c5786851e86b000c31d89100b7e881.woff";